export default __webpack_public_path__ + "3f1944b01399207b53b6971e62bde8dd.svg";